<template>
	<label
		class="app-radio-button"
		:class="{'app-radio-button--disabled' : $attrs.disabled}"
	>
		<input
			type="radio"
			class="app-radio-button__input"
			v-bind="$attrs"
			:checked="$attrs.value === modelValue"
			@change="event => $emit('change', event.target.value)"
		>
		<div class="app-radio-button__mark"></div>
		<div class="slot"><slot></slot></div>
	</label>
</template>

<script>
export default {
	inheritAttrs: false,

	props: {
		modelValue: {default: ''}
	},

	model: {
		prop: 'modelValue',
		event: 'change'
	}
}
</script>

<style lang="scss" scoped>
.app-radio-button {
	display: inline-flex;
	align-items: center;
	user-select: none;
	position: relative;
	cursor: pointer;

	&__input {
		appearance: none;
		outline: none;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
	}

	&__mark {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px solid $default-light;
		background-color: #fff;
		height: 1em;
		width: 1em;
		border-radius: 50%;
		margin-right: 5px;
	}

	&__input:checked ~ &__mark {
		background-color: $primary;
		border-color: $primary;
	}

	&:hover &__mark {
		border-color: $primary;
	}

	&--disabled {
		pointer-events: none;
		opacity: 0.5;
	}
}
</style>
